export default __webpack_public_path__ + "static/media/default-location-filled.991e0f6a.svg";